module.exports = __webpack_public_path__ + "static/media/bcp.704daf67.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/pay-methods/bcp.png
// module id = 573
// module chunks = 0